module.exports = __webpack_public_path__ + "24dfb0e50c722da8348bd398c4c974e4.svg";